import queryString from "query-string";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Loader } from "../../components";
import Form from "./create audience components/Form";
import {
  audienceObject,
  objectFromResponse,
} from "./create audience components/audienceObjects";
import { useAxios, useComponent } from "../../hooks";

export default function AudienceDetails() {
  const axios = useAxios();
  const params = useParams();
  const { loader } = useComponent();

  const audienceID = params.audienceID || "";
  const mode = queryString.parse(window.location.search).mode;

  const [fields, setFields] = useState({});
  const [message, setMessage] = useState(false);
  const [editState, setEditState] = useState(true);
  const [formData, setFormData] = useState(audienceObject);

  useEffect(() => {
    if (!!audienceID) {
      setEditState(false);
    } else {
      setEditState(true);
      setFormData(audienceObject);
    }

    if (mode === "edit") {
      setEditState(true);
    }

    loader.start(2);
    axios({
      url: "/adtech/getAllDynamicFields",
      method: "GET",
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          let data = {
            ioh: [],
            other: [],
          };
          var fields = response.data;
          for (let key of fields) {
            if (key.is_ioh_contributor) {
              data.ioh.push(key);
            } else {
              data.other.push(key);
            }
          }
          setFields(data);

          if (!!audienceID) {
            axios({
              url: "/brand/getDetailsOfAudience/" + audienceID,
              method: "GET",
            }).then((responses) => {
              if (responses.status) {
                let data = objectFromResponse(responses.data, fields);
                setFormData(data);
                loader.apiComplete();
                loader.apiComplete();
              }
            });
          } else {
            loader.stop();
            setFormData(audienceObject);
          }
        } else {
          loader.stop();
          StyleSheetList(true);
        }
      })
      .catch((err) => console.error(err));
  }, [axios, audienceID, mode, loader]);

  return (
    <Loader>
      <Form
        fields={fields}
        formData={formData}
        editState={editState}
        setEditState={setEditState}
      />
    </Loader>
  );
}
